import React, { useState, useEffect, useMemo, useContext } from "react";
import axios from "axios";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import Box from "@mui/material/Box";
import { useSelector, useDispatch } from "react-redux";
import { GetCompetitorJobIds as GetCompetitorInJobIds } from "../../../Store/CompetitorInJobId";
import { SetredirectValue } from "../../../Store/PageredirectSlice";
import { Commonfun, datezonechange, removeDuplicateDate, timezonechange } from './../Commonfun';
import Commoncard from "../Commoncard";
import Rightsidebar from "../Rightsidebar/Rightsidebar";
import Loader from "../CommonLoader";
import Tooltip from "@mui/material/Tooltip";
import { Link } from "react-router-dom";
import LinkIcon from '@mui/icons-material/Link';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Button from "@mui/material/Button";
import useMediaQuery from '@mui/material/useMediaQuery';
import CommonAlert from "../../../Commonalert/commonalert";
import DatagridComp from "../DatagridComp";
import { CommonErrorAlert } from "../../../Commonalert/commonErrorAlert";
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import { timezoneval } from './../Commonfun';
import { ToastContainer, toast } from 'react-toastify';
import { AppContext } from "../../../Context/Context";
import { useParams } from "react-router-dom";
import CommonBreadCrumb from "../../../Commonalert/commonbreadcrumb";

import jserror from "../Asset/esocardicon/network/totalrequest.svg"
import failedrequest from "../Asset/esocardicon/network/failedrequest.svg"
import deprecationserror from "../Asset/esocardicon/network/deprecationserror.svg"
import totalrequest from "../Asset/esocardicon/network/jserror.svg"
import UserActivityTracker from "../../../hooks/userActivityTracker";

export default function NetworkHealthSummaryDetail() {
  const { isMenuExpanded, setIsMenuExpanded } = useContext(AppContext);
  const isMobile = useMediaQuery('(max-width:480px)');
  const [cardData, setCardData] = useState([]);
  const [sitecardData, setSitecardData] = useState([]);
  const [internalcardData, setInternalcardData] = useState([]);
  const [outercardData, setOutercardData] = useState([]);
  const [jobidData, setjobidData] = useState("");
  const [loading, setLoading] = useState(false);
  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [jobDate, setjobDate] = useState("");
  const [serveritydata, setServeritydata] = useState([]);
  const [value, setValue] = useState("1");
  const esodata = useSelector((state) => state);
  const ApiToken = esodata.apiauthkey.value;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [autoheightval, SetAutoheightval] = useState(true)
  const [autoheightval1, SetAutoheightval1] = useState(true)
  const [autoheightval2, SetAutoheightval2] = useState(true)
  const [autoheightval3, SetAutoheightval3] = useState(true)
  const [apiopen, setapiOpen] = React.useState(false);
  const [apierrorMsg, setapierrorMsg] = useState();
  const [openCommonAlerts, setOpenCommonAlerts] = useState(false);
  const [JobId, SetJobId] = useState("");
  const [tableLoading, setTableLoading] = useState(true);
  const [dEngineoption, SetdEngineoption] = useState({
    completed_at:
      'Select Date',
    id:
      'Select Date',
  });
  const [WarningsCarddata, SetWarningsCarddata] = useState([]);
  const [faqData, setfaqData] = useState("2")
  const [performancePlan, setperformancePlan] = useState({ status: true, error: "" });
  const [isDownloadingcsv, setIsDownloadingcsv] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [wholedata, setWholedata] = useState(false);
  const [initialfaqDateval, SetInitialfaqDateval] = useState([]);
  const [toggle, setToggle] = useState(false);
  const apihandleClose = () => {
    setapiOpen(false);
  };
  let querystring = useParams();
  let content_structure_id = querystring.id;

  useEffect(() => {
    dispatch(GetCompetitorInJobIds(esodata.domaindata.value.header_selected));
    callUserdataApi();
    faqdatafun();
  }, []);
  const handleModelPopUp = () => {
    openModal();
  }
  const handleDownlodingCSV = () => {
    csvdown();
  }

  const handleDownlodingPDF = () => {
    pdfdown();
  }
  function openModal() {
    if (performancePlan.status) {
      setIsOpen(true);
    }
  }
  const faqdatafun = async (menubutval = "") => {
    var datavar = `${process.env.REACT_APP_API_URL}domain/frequently_asked_questions/?menu=77`

    try {
      const doaminsectiondatavalue = await axios.get(
        datavar,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      );
      if (doaminsectiondatavalue?.data) {
        SetInitialfaqDateval(doaminsectiondatavalue?.data?.faqs)
      }
    } catch (err) { }
  }
  const csvdown = async () => {
    setLoading(true);
    setIsDownloadingcsv(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/network_health_detail/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=csv&link_id=${content_structure_id}&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        var filedata = await Commonfun("networkhealthsummarydetail", "csv", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloadingcsv(false);

  }
  const pdfdown = async () => {

    setLoading(true);
    setIsDownloading(true);
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}technical/network_health_detail/?user_domain_id=${esodata.domaindata.value.header_selected}&formats=pdf&link_id=${content_structure_id}&timezone=${timezoneval()}`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/pdf',
          Authorization: `${ApiToken}`,
        },
      });

      if (response.ok) {

        const blob = await response.blob();


        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);

        var filedata = await Commonfun("Networkhealthsummarydetail", "pdf", ApiToken, esodata.domaindata.value.header_selected);
        link.download = filedata;
        link.click();


        window.URL.revokeObjectURL(link.href);
      } else {
        if (response?.status == 599 || response?.status == 500 || response?.status == 400 || response?.status == 404) {
          response.json().then(data => {
            setapiOpen(true);
            setapierrorMsg(data?.error)
          })
        }
        else if (response?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      }
    } catch (error) {
      toast.error("No Data", {
        position: "top-center",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      });
      console.error('Error during PDF download:', error);
    }
    setLoading(false);
    setIsDownloading(false);


  }
  const columns = [

    {
      field: "url",
      headerName: "Request URL",
      description: "The web address of the resource",
      minWidth: 350,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      sortable: true,
      renderCell: (cardData) => {

        let isUrl = cardData.row.url.includes('https://');
        let baseUrl = cardData.row.url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.url.split("/").slice(3).join("/");

        return (
          <>
            {isUrl ?
              <Tooltip title={cardData.row.url}>
                <div className="prefered_url_external02">
                  <a
                    target="_blank"
                    href={cardData?.row?.url}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <span className="spanlink">
                      <LinkIcon /> {baseUrl}
                    </span>
                    <span
                      className="spanlink"
                      style={{
                        color: "#044792",
                        wordWrap: "break-word",
                        wordBreak: "break-word",
                      }}
                    >
                      {remaining}
                    </span>
                  </a>
                </div>
              </Tooltip> :
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span
                  className="spanlink"
                  style={{
                    color: "#044792",
                    wordWrap: "break-word",
                    wordBreak: "break-word",
                  }}>
                  {cardData.row.url.slice(0, 30) + '...'}
                </span>
              </div>
            }
          </>
        );

      },

    },
    {
      field: "mimeType",
      headerName: "MIME Type",
      description: "The type of content being loaded.",
      minWidth: 250,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
    },
    {
      field: "load_time",
      headerName: "Load Time(s)",
      description: "Time taken to load the resource",
      minWidth: 180,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "priority",
      headerName: "Priority",
      description: "Importance level",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "resourceType",
      headerName: "Resource Type",
      description: "Type of asset requested",
      minWidth: 200,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
  ];
  const column1 = [
    {
      field: "url",
      headerName: "Request URL",
      description: "Component where the feature was used.",
      minWidth: 350,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      sortable: true,
      renderCell: (cardData) => {

        let isUrl = cardData.row.url.includes('https://');
        let baseUrl = cardData.row.url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.url.split("/").slice(3).join("/");

        return (
          <>
            {isUrl ?
              <Tooltip title={cardData.row.url}>
                <div className="prefered_url_external02">
                  <a
                    target="_blank"
                    href={cardData?.row?.url}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <span className="spanlink">
                      <LinkIcon /> {baseUrl}
                    </span>
                    <span
                      className="spanlink"
                      style={{
                        color: "#044792",
                        wordWrap: "break-word",
                        wordBreak: "break-word",
                      }}
                    >
                      {remaining}
                    </span>
                  </a>
                </div>
              </Tooltip> :
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span
                  className="spanlink"
                  style={{
                    color: "#044792",
                    wordWrap: "break-word",
                    wordBreak: "break-word",
                  }}>
                  {cardData.row.url.slice(0, 30) + '...'}
                </span>
              </div>
            }
          </>
        );

      },

    },
    {
      field: "description",
      headerName: "Description",
      description: "Description",
      minWidth: 250,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      sortable: true,
    },
    {
      field: "line",
      headerName: "Line",
      description: "Location in the source file",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
    {
      field: "column",
      headerName: "Column",
      description: "Location in the source file",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
    },
  ];
  const column2 = [
    {
      field: "url",
      headerName: "Request URL",
      description: "Component where the feature was used.",
      minWidth: 350,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      sortable: true,
      renderCell: (cardData) => {

        let isUrl = cardData.row.url.includes('https://');
        let baseUrl = cardData.row.url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.url.split("/").slice(3).join("/");

        return (
          <>
            {isUrl ?
              <Tooltip title={cardData.row.url}>
                <div className="prefered_url_external02">
                  <a
                    target="_blank"
                    href={cardData?.row?.url}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <span className="spanlink">
                      <LinkIcon /> {baseUrl}
                    </span>
                    <span
                      className="spanlink"
                      style={{
                        color: "#044792",
                        wordWrap: "break-word",
                        wordBreak: "break-word",
                      }}
                    >
                      {remaining}
                    </span>
                  </a>
                </div>
              </Tooltip> :
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span
                  className="spanlink"
                  style={{
                    color: "#044792",
                    wordWrap: "break-word",
                    wordBreak: "break-word",
                  }}>
                  {cardData.row.url.slice(0, 30) + '...'}
                </span>
              </div>
            }
          </>
        );

      },

    },
    {
      field: "description",
      headerName: "Description",
      description: "Description.",
      minWidth: 250,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,

      renderCell: (cardData) => {
        return (
          <p className="button_score_org">{`${cardData?.row?.priority}`}</p>
        );
      },
    },

  ];
  const column3 = [
    {
      field: "url",
      headerName: "Request URL",
      description: "Component where the feature was used.",
      minWidth: 350,
      flex: 1,
      disableClickEventBubbling: true,
      headerAlign: "center",
      align: "center",
      sortable: true,
      renderCell: (cardData) => {

        let isUrl = cardData.row.url.includes('https://');
        let baseUrl = cardData.row.url.split("/").slice(0, 3).join("/") + "/";
        let remaining = cardData.row.url.split("/").slice(3).join("/");

        return (
          <>
            {isUrl ?
              <Tooltip title={cardData.row.url}>
                <div className="prefered_url_external02">
                  <a
                    target="_blank"
                    href={cardData?.row?.url}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <span className="spanlink">
                      <LinkIcon /> {baseUrl}
                    </span>
                    <span
                      className="spanlink"
                      style={{
                        color: "#044792",
                        wordWrap: "break-word",
                        wordBreak: "break-word",
                      }}
                    >
                      {remaining}
                    </span>
                  </a>
                </div>
              </Tooltip> :
              <div style={{ display: "flex", flexDirection: "column" }}>
                <span
                  className="spanlink"
                  style={{
                    color: "#044792",
                    wordWrap: "break-word",
                    wordBreak: "break-word",
                  }}>
                  {cardData.row.url.slice(0, 30) + '...'}
                </span>
              </div>
            }
          </>
        );

      },

    },
    {
      field: "status_code",
      headerName: "Status Code",
      description: "HTTP response code.",
      minWidth: 150,
      flex: 1,
      headerAlign: "center",
      align: "center",
      sortable: true,
    },

  ];
  const rows = cardData ?? [];
  const rows1 = sitecardData ?? [];
  const rows2 = internalcardData ?? [];
  const rows3 = outercardData ?? [];

  const callUserdataApi = async (jobid = "") => {
    setLoading(true);
    setTableLoading(true);

    const datavalue = await axios
      .get(
        `${process.env.REACT_APP_API_URL}technical/network_health_detail/?user_domain_id=${esodata.domaindata.value.header_selected}&domain_section_id=${esodata.sectiondomaindata.value}&link_id=${content_structure_id}`,
        {
          headers: {
            Authorization: `${ApiToken}`,
          },
        }
      )
      .catch((error) => {
        if (error?.response?.status == 599 || error?.response?.status == 500 || error?.response?.status == 400 || error?.response?.status == 404) {
          setapiOpen(true);
          setapierrorMsg(error?.response?.data?.error)
        }
        else if (error?.code == "ERR_NETWORK") {
          navigate('/errorpages')
        }
      });

    if (datavalue?.data) {
      SetWarningsCarddata(datavalue?.data?.result)
      setWholedata(datavalue?.data?.result?.network_health)
      const dataval = datavalue?.data?.result?.network_health?.requests?.requests_details;
      const dataval1 = datavalue?.data?.result?.network_health?.console_errors?.error_details;
      const dataval2 = datavalue?.data?.result?.network_health?.deprecations?.deprecation_details;
      const dataval3 = datavalue?.data?.result?.network_health?.failed_requests?.failed_network_requests;

      const severity_dataarrvals = [];
      setServeritydata(severity_dataarrvals);

      if (dataval) {
        const newData = dataval.map((obj, index) => {
          return { ...obj, sid: index + 1 };
        });

        if (dataval && dataval.length > 0) {
          SetAutoheightval(false)
        }
        else {
          SetAutoheightval(true)
        }

        setCardData(newData);
        setjobDate(moment(datavalue?.data?.job_date).format("MMMM DD,YYYY HH:mm"));
      }

      if (dataval1) {
        const newData1 = dataval1.map((obj, index) => {
          return { ...obj, sid: index + 1 };
        });
        if (dataval1 && dataval1.length > 0) {
          setSitecardData(newData1);
          SetAutoheightval1(false)
        }
        else {
          setSitecardData("");
          SetAutoheightval1(true)
        }
      }

      if (dataval2) {
        const newData2 = dataval2.map((obj, index) => {
          return { ...obj, sid: index + 1 };
        });
        if (dataval2 && dataval2.length > 0) {
          setInternalcardData(newData2);
          SetAutoheightval2(false)
        }
        else {
          setInternalcardData("");
          SetAutoheightval2(true)
        }
      }
      if (dataval3) {
        const newData3 = dataval3.map((obj, index) => {
          return { ...obj, sid: index + 1 };
        });
        if (dataval3 && dataval3.length > 0) {
          setOutercardData(newData3);
          SetAutoheightval3(false)
        }
        else {
          setOutercardData("");
          SetAutoheightval3(true)
        }
      }

    };
    setTableLoading(false);
    setLoading(false);

  }
  const handleToggle = () => {

    if (faqData != 1) {
      setfaqData(1)
    }
    else {
      setfaqData(2)
    }
    setToggle((pre) => !pre);
  };

  const SwitchActiveTableTab = (cardId) => {
    setValue(cardId)
  }


  const cardDatas = [
    {
      route: '1',
      value: wholedata?.requests?.request_count || 0,
      title: "Total Request",
      badge: "Request",
      iconSrc: totalrequest,
      iconColor: 1,
      bgColor: 1,
      handleCardClick: SwitchActiveTableTab
    },
    {
      route: '2',
      value: wholedata?.console_errors?.error_count || 0,
      title: "Js Errors",
      badge: "Console",
      iconSrc: jserror,
      iconColor: 2,
      bgColor: 2,
      handleCardClick: SwitchActiveTableTab

    },
    {
      route: '3',
      value: wholedata?.deprecations?.deprecations_count || 0,
      title: "Deprecations Count",
      badge: "Deprecations",
      iconSrc: deprecationserror,
      iconColor: 3,
      bgColor: 3,
      handleCardClick: SwitchActiveTableTab

    },
    {
      route: '4',
      value: wholedata?.failed_requests?.failed_count || 0,
      title: "Failed Request",
      badge: "Request",
      iconSrc: failedrequest,
      iconColor: 4,
      bgColor: 4,
      handleCardClick: SwitchActiveTableTab
    },

  ];

  return (
    <div className={`over_all_container ${isMenuExpanded ? "blur overflow-hidden" : ""}`}>
      <Helmet>
        <meta charSet="utf-8" />
        <title></title>
      </Helmet>
      {loading === true ? <Loader /> : null}
      <CommonAlert setOpenCommonAlerts={setOpenCommonAlerts} />
      <p className=" dummysiteheader" >
      </p>
      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={4}>
              <div>
                <h1 className="dashboard_header">
                  Network Health Summary Detail
                  <span className="faq-chip" onClick={handleToggle}>FAQ's</span>
                </h1>
              </div>
            </Grid>
            <Grid item xs={12} md={8}>
              <div className="top_breadcrumb_menu">
                <div className="exportpdf_outer">
                  <div className="breadcrumb-wrapper">
                    <CommonBreadCrumb breadcrumbValue={[
                      { title: 'Technical' },
                      { title: 'Performance Analysis' },
                      { title: 'Network Health Summary', activeColor: true, link: '/network-health-summary' },
                      { title: 'Network Health Summary Detail', activeColor: true }
                    ]} />
                  </div>
                </div>
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="dashboard-box-time">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={6}>

              <div className="time_zone">
                <span><a target="_blank" href={WarningsCarddata?.link_url}>
                  <span style={{ display: 'inline-block' }} className="spanlink">
                    {WarningsCarddata?.link_url}
                  </span>
                </a>
                </span><br></br>
                <span className="timezone-date">{timezonechange(jobDate)} </span><br />
                <span className="timezone-val">{timezoneval()}</span>
              </div>
            </Grid>

            <Grid item xs={12} md={6}>
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-card-container">
        <Box >
          <Grid container className="dashboard-box-card">
            <Grid container spacing={3} justifyContent="center">
              {cardDatas.map((item, index) => (
                <Grid item xs={12} sm={6} md={3} key={item.id}>
                  <Commoncard
                    item={item}
                    nonclikable={false}
                  />
                </Grid>
              ))}
            </Grid>
          </Grid>
        </Box>
      </Container>

      <Container maxWidth={false} className="dashboard-container">
        <Box className="grid_table_shodow">
          <Grid container className="dashboard-grid">
            <Grid item xs={12} md={12}>
              <div className="cnt_audit_outer_wrap">
                {value === "1" &&
                  <DatagridComp
                    columns={columns}
                    rows={rows}
                    autoheightval={autoheightval}
                    datagridval={2}
                    columnFreezeWidth={[0, 320]}
                    tableLoading={tableLoading}
                    handleModelPopUp={handleModelPopUp}
                    handleDownlodingCSV={handleDownlodingCSV}
                    handleDownlodingPDF={handleDownlodingPDF}
                    customFilter={false}
                    DownloadShowFile={true}
                    DownloadShowPDF={1}
                    DownloadShowCSV={2}
                  />
                }
                {value === "2" &&
                  <DatagridComp
                    columns={column1}
                    rows={rows1}
                    autoheightval={autoheightval}
                    datagridval={2}
                    columnFreezeWidth={[0, 320]}
                    tableLoading={tableLoading}
                    handleModelPopUp={handleModelPopUp}
                    handleDownlodingCSV={handleDownlodingCSV}
                    handleDownlodingPDF={handleDownlodingPDF}
                    customFilter={false}
                    DownloadShowFile={true}
                    DownloadShowPDF={1}
                    DownloadShowCSV={2}
                  />
                }
                {value === "3" &&
                  <DatagridComp
                    columns={column2}
                    rows={rows2}
                    autoheightval={autoheightval}
                    datagridval={2}
                    columnFreezeWidth={[0, 320]}
                    tableLoading={tableLoading}
                    handleModelPopUp={handleModelPopUp}
                    handleDownlodingCSV={handleDownlodingCSV}
                    handleDownlodingPDF={handleDownlodingPDF}
                    customFilter={false}
                    DownloadShowFile={true}
                    DownloadShowPDF={1}
                    DownloadShowCSV={2}
                  />
                }
                {value === "4" &&
                  <DatagridComp
                    columns={column3}
                    rows={rows3}
                    autoheightval={autoheightval}
                    datagridval={2}
                    columnFreezeWidth={[0, 320]}
                    tableLoading={tableLoading}
                    handleModelPopUp={handleModelPopUp}
                    handleDownlodingCSV={handleDownlodingCSV}
                    handleDownlodingPDF={handleDownlodingPDF}
                    customFilter={false}
                    DownloadShowFile={true}
                    DownloadShowPDF={1}
                    DownloadShowCSV={2}
                  />
                }
              </div>
            </Grid>
          </Grid>
        </Box>
      </Container>
      {toggle && <Rightsidebar close={() => setToggle(false)} setToggle={setToggle} initialfaqDateval={initialfaqDateval} />}

      {!openCommonAlerts &&
        <CommonErrorAlert
          data={{
            apiopen: apiopen,
            apiErrorMsg: apierrorMsg,
            isIconStyled: true
          }}
          closeAlert={apihandleClose} />

      }
            <UserActivityTracker pagename="Technical - Performance Analysis - Network Health Summary - Network Health Summary Detail" />
    </div>
  );
}
